import Content from "uxp-documentation/src/pages/uxp-api/reference-html/General/body";
import * as React from 'react';
export default {
  Content,
  React
};